module.exports = __webpack_public_path__ + "static/img/Honey_Cocaine.ba5b0a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Honey_Cocaine.jpg
// module id = tU80
// module chunks = 1